const drawOnTop = {
  schema: {
    renderOrder: { default: 1 },
  },

  init() {
    this.el.sceneEl.renderer.sortObjects = true;
    this.el.object3D.renderOrder = this.data.renderOrder;
    this.el.components.material.material.depthTest = false;
    //console.log('drawOnTop init() - renderOrder:', this.data.renderOrder, ', object3D:', this.el.object3D);
  },
};

export default drawOnTop;
